/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown>, changes: NonNullable<unknown> }} Uno_Confirm_Update_ProjectInputs */



/**
* | output |
* | --- |
* | "Update the project “{project}”: {changes}" |
*
* @param {Uno_Confirm_Update_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_confirm_update_project = /** @type {((inputs: Uno_Confirm_Update_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Confirm_Update_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt „${i?.project}“ aktualisieren: ${i?.changes}`)
	return /** @type {LocalizedString} */ (`Update the project “${i?.project}”: ${i?.changes}`)
});